import * as React from 'react';

import cn from 'classnames';

export type LabelKind =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'
  | 'muted'
  | 'default'
  | 'purple'
  | 'mint';

export const Label: React.FC<{
  kind?: LabelKind;
  className?: string;
  style?: React.CSSProperties;
}> = ({ children, kind, className, style }) => (
  <span className={cn(className, 'label', kind && `label-${kind}`)} style={style}>
    {children}
  </span>
);
